import { JSResourceForUserVisible } from '@atlassian/react-async';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const issueNavigatorPinRedirectEntrypoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(
				/* webpackChunkName: "async-project-issue-navigator-pin-redirect-entrypoint" */ './index.tsx'
			),
		{ entryFsSsrLiftImportToModule: false },
	),
	getPreloadProps: () => ({}),
});
